// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var merchantRouter = {
  path: '/merchant',
  component: Layout,
  redirect: '/merchant/list',
  name: 'Merchant',
  meta: {
    title: '店铺',
    icon: 'clipboard'
  },
  children: [{
    path: 'manage/index',
    name: 'MerchantManageIndex',
    component: function component() {
      return import('@/views/merchant/index');
    },
    redirect: '/merchant/list',
    meta: {
      title: '店铺管理',
      icon: ''
    }
  }, {
    path: 'store/index',
    name: 'MerchantStoreIndex',
    component: function component() {
      return import('@/views/merchant/index');
    },
    redirect: '/merchant/system',
    meta: {
      title: '店铺设置',
      icon: ''
    }
  }, {
    path: '/platform/business/index',
    name: 'PlatformBusinessIndex',
    component: function component() {
      return import('@/views/merchant/index');
    },
    redirect: '/platform/business/list',
    meta: {
      title: '商户管理',
      icon: 'el-icon-s-shop'
    }
  }, {
    path: '/platform/business/list',
    name: 'PlatformBusinessList',
    component: function component() {
      return import('@/views/platform/business/list/index.vue');
    },
    meta: {
      title: '商户列表',
      icon: ''
    }
  }, {
    path: '/platform/business/apply',
    name: 'PlatformBusinessApply',
    component: function component() {
      return import('@/views/merchant/application');
    },
    meta: {
      title: '商户入驻审核',
      icon: '',
      applyType: 'business'
    }
  },
  // TODO: 暂未发布，当前版本不更新区域功能
  {
    path: '/platform/region/index',
    name: 'PlatformRegionIndex',
    component: function component() {
      return import('@/views/merchant/index');
    },
    redirect: '/platform/region/area/list',
    meta: {
      title: '区域代理',
      icon: 'el-icon-map-location'
    }
  },
  // TODO: 暂未发布，当前版本不更新区域功能
  {
    path: '/platform/region/area/list',
    name: 'PlatformRegionAreaList',
    component: function component() {
      return import('@/views/platform/region/area/list.vue');
    },
    meta: {
      title: '区域列表',
      icon: ''
    }
  },
  // TODO: 暂未发布，当前版本不更新区域功能
  {
    path: '/platform/region/agent/list',
    name: 'PlatformRegionAgentList',
    component: function component() {
      return import('@/views/platform/region/agent/list.vue');
    },
    meta: {
      title: '代理人员',
      icon: ''
    }
  },
  // TODO: 暂未发布，当前版本不更新区域功能
  {
    path: '/platform/region/apply/list',
    name: 'PlatformRegionApplyList',
    component: function component() {
      return import('@/views/platform/region/apply/list.vue');
    },
    meta: {
      title: '代理审核',
      icon: ''
    }
  },
  // TODO: 暂未发布，当前版本不更新区域功能
  {
    path: '/platform/region/config/list',
    name: 'PlatformRegionConfigList',
    component: function component() {
      return import('@/views/platform/region/config/list.vue');
    },
    meta: {
      title: '代理设置',
      icon: ''
    }
  }, {
    path: 'classify',
    name: 'MerchantAlassify',
    component: function component() {
      return import('@/views/merchant/classify');
    },
    meta: {
      title: '店铺分类',
      icon: ''
    }
  }, {
    path: 'list',
    name: 'MerchantList',
    component: function component() {
      return import('@/views/merchant/list');
    },
    meta: {
      title: '店铺列表',
      icon: ''
    }
  }, {
    path: 'system',
    name: 'MerchantAystem',
    component: function component() {
      return import('@/views/merchant/system');
    },
    meta: {
      title: '店铺菜单',
      icon: ''
    }
  }, {
    path: 'application',
    name: 'MerchantApplication',
    component: function component() {
      return import('@/views/merchant/application');
    },
    meta: {
      title: '店铺入驻申请',
      icon: ''
    }
  }, {
    path: 'type',
    name: 'MerchantType',
    component: function component() {
      return import('@/views/merchant/type');
    },
    meta: {
      title: '店铺类型',
      icon: 'clipboard'
    },
    children: [{
      path: 'list',
      component: function component() {
        return import('@/views/merchant/type/list');
      },
      name: 'MerchantTypeList',
      meta: {
        title: '店铺类型',
        icon: ''
      }
    }]
  }]
};
export default merchantRouter;